import React from "react";
import FormResetPassword from "ui/form-reset-password";

export default function Page() {
  return (
    <main
      className="flex flex-col items-center justify-center md:h-screen bg-slate-50 bg-cover bg-center"
      style={{ backgroundImage: "url(/auth/background-login.png)" }}
    >
      <h1 className="text-4xl leading-snug font-bold text-center mb-8">
        Our Mission is to protect people and property with <br />
        Simple Smart Scalable Solution
      </h1>
      <div className="max-w-[400px] w-full">
        <FormResetPassword />
      </div>
    </main>
  );
}
